module.exports = __webpack_public_path__ + "img/caret-right-black.35670ebd.svg";